<script setup lang="ts">
import { OdsDivider } from "@ods/lidl-web-vuejs";
import { getGridboxType } from "@reco/service/src/utils/helpers";

import type { LocaleContext } from "@reco/shared/src/composables/useLocale";
import type { GridBox } from "@reco/shared/src/types/gridbox";

type Props = {
  product: GridBox;
  localeContext: LocaleContext;
};
const props = defineProps<Props>();

const { t } = useI18n();
const header = computed(() => t("reco-frontend-next.RDP.currently_viewing"));
const dataType = computed(() => getGridboxType(props.localeContext.country, props.product.list));
</script>

<template>
  <div class="product-card">
    <header id="product-card__header" class="product-card__header">
      <h1>{{ header }}</h1>
    </header>
    <OdsDivider />
    <div
      data-grid-label="grid-fragment-v2"
      :data-grid-data="prepareGridData(product)"
      :data-country="localeContext.country"
      :data-language="localeContext.language"
      :data-type="dataType"
    />
  </div>
</template>

<style lang="scss" scoped>
.product-card {
  @include ods-box-shadow();

  border-radius: var(--ods-border-radius-4);
  background-color: var(--ods-color-bg-default);
  color: var(--ods-color-text-surface-primary);
  margin-top: var(--ods-space-8);
  border-radius: 8px;
  display: grid;

  @media (max-width: $ods-breakpoint-tablet-portrait-max) {
    max-width: 21rem;
  }

  &__header {
    padding: var(--ods-space-8) var(--ods-space-8) var(--ods-space-4) var(--ods-space-8);

    h1 {
      font-size: var(--ods-typography-font-size-16);
      font-weight: var(--ods-typography-font-weight-strong);
      padding: 0;
      margin: 0;
    }
  }

  :deep(.ods-divider) {
    margin: var(--ods-space-4) var(--ods-space-8) var(--ods-space-4) var(--ods-space-8);
  }
}
</style>
